import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
import { toast } from "react-toastify";
import { BonProductieForm } from "./Form";

export default function BonProductieCreate() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (payload) => {
    setBusy(true);
    try {
      const created = await authFetch("/bon-productie/", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      const id = created?.id;
      toast.success("Bonul de producție a fost creat și înregistrat cu succes!");
      if (id) {
        navigate(`/bon-productie/${id}`);
      } else {
        navigate("/bon-productie");
      }
    } catch (e) {
      toast.error(`Eroare la salvare: ${e?.message || e}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Container className="py-3">
      <Card className="shadow-sm">
        <Card.Header className="bg-success text-white">
          <h4 className="mb-0">Bon de Producție Nou</h4>
        </Card.Header>
        <Card.Body>
          <BonProductieForm onSubmit={handleSubmit} busy={busy} isClosed={false} />
        </Card.Body>
      </Card>
    </Container>
  );
}
